import { LuSearch, BsThreeDots } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "35%",
      rows: {
        row1: [
          {
            name: "Preferred Cartage Handler",
            component: "header",
          },
        ],
        row2: [
          {
            name: "cartageHandlerAir",
            label: "For Air",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            iconColor: "gray-400",
            endpoint: "getCustomer",
            type: "autocomplete",
          },
        ],
        row3: [
          {
            name: "cartageHandlerLCL",
            label: "For LCL",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            endpoint: "getCustomer",
            type: "autocomplete",
          },
        ],
        row4: [
          {
            name: "cartageHandlerFCL",
            label: "For FCL",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getCustomer",
            type: "autocomplete",
          },
        ],
        row5: [
          {
            name: "Customer Services",
            component: "header",
          },
        ],
        row6: [
          {
            name: "customerServiceSea",
            label: "For Sea",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getShipperQuery",
            type: "autocomplete",
          },
        ],
        row7: [
          {
            name: "customerServiceAir",
            label: "For Air",
            component: "text-field",
            endpoint: "getShipperQuery",
            type: "autocomplete",
            icon: LuSearch,
            iconColor: "gray-400",
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "40%",
      rows: {
        row1: [
          {
            name: "Account Manager",
            component: "header",
          },
        ],
        row2: [
          {
            name: "accountManagerSea",
            label: "For Sea",
            component: "dropdown",

            endIconName: "LuChevronDown",
            // placeholder: "3 M EXIM PVT LTD",
            width: "90%",
            icon: LuSearch,
            iconColor: "gray-400",
            options: [
              { label: "Administrator", value: "Administrator" },
              { label: "Ajitesh Barick", value: "Ajitesh Barick" },
              { label: "Anjan Reddy", value: "Anjan Reddy" },
              { label: "Boopathy", value: "Boopathy" },
              { label: "Chandra", value: "Chandra" },
              { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
              { label: "Export Del", value: "Export Del" },
              { label: "Karthik", value: "Karthik" },
              { label: "Kiran Kumar V", value: "Kiran Kumar V" },
              { label: "Mohan Reddy", value: "Mohan Reddy" },
              { label: "Mythri", value: "Mythri" },
              { label: "Shiva", value: "Shiva" },
              { label: "SUREKSHA", value: "SUREKSHA" },
              { label: "TAPAN", value: "TAPAN" },
              { label: "Tripath Mumbai", value: "Tripath Mumbai" },
              { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
              { label: "TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
            ],
          },
        ],
        row3: [
          {
            name: "accountManagerAir",
            label: "For Air",
            component: "dropdown",
            endIconName: "LuChevronDown",
            // placeholder: "3 M EXIM PVT LTD",
            width: "90%",
            icon: LuSearch,
            iconColor: "gray-400",
            options: [
              { label: "Administrator", value: "Administrator" },
              { label: "Ajitesh Barick", value: "Ajitesh Barick" },
              { label: "Anjan Reddy", value: "Anjan Reddy" },
              { label: "Boopathy", value: "Boopathy" },
              { label: "Chandra", value: "Chandra" },
              { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
              { label: "Export Del", value: "Export Del" },
              { label: "Karthik", value: "Karthik" },
              { label: "Kiran Kumar V", value: "Kiran Kumar V" },
              { label: "Mohan Reddy", value: "Mohan Reddy" },
              { label: "Mythri", value: "Mythri" },
              { label: "Shiva", value: "Shiva" },
              { label: "SUREKSHA", value: "SUREKSHA" },
              { label: "TAPAN", value: "TAPAN" },
              { label: "Tripath Mumbai", value: "Tripath Mumbai" },
              { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
              { label: "TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
            ],
          },
        ],
        row4: [
          {
            name: "accountManagerLand",
            label: "For Land",
            component: "dropdown",
            endIconName: "LuChevronDown",
            // placeholder: "3 M EXIM PVT LTD",
            width: "90%",
            options: [
              { label: "Administrator", value: "Administrator" },
              { label: "Ajitesh Barick", value: "Ajitesh Barick" },
              { label: "Anjan Reddy", value: "Anjan Reddy" },
              { label: "Boopathy", value: "Boopathy" },
              { label: "Chandra", value: "Chandra" },
              { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
              { label: "Export Del", value: "Export Del" },
              { label: "Karthik", value: "Karthik" },
              { label: "Kiran Kumar V", value: "Kiran Kumar V" },
              { label: "Mohan Reddy", value: "Mohan Reddy" },
              { label: "Mythri", value: "Mythri" },
              { label: "Shiva", value: "Shiva" },
              { label: "SUREKSHA", value: "SUREKSHA" },
              { label: "TAPAN", value: "TAPAN" },
              { label: "Tripath Mumbai", value: "Tripath Mumbai" },
              { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
              { label: "TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
            ],
          },
        ],
        row5: [
          {
            name: "Cartage Coordinator",
            component: "header",
          },
        ],

        row6: [
          {
            name: "cartageCoordinatorSea",
            label: "For Sea",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            width: "90%",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getShipperQuery",
            type: "autocomplete",
          },
        ],
        row7: [
          {
            name: "cartageCoordinatorAir",
            label: "For Air",
            component: "text-field",
            // placeholder: "3 M EXIM PVT LTD",
            width: "90%",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getShipperQuery",
            type: "autocomplete",
          },
        ],
      },
    },
  ],
};
